<div [formGroup]="rateUnitForm" class="text-small text-center">
    <select formControlName="rateUnits" class="custom-select custom-select-sm form-control-secondary form-control mx-auto" style="width: 200px;" (change)="changeUnits()">
        <option *ngFor="let unit of units" [value]="unit.name">{{ unit.label }}</option>
    </select>
</div>
